<template>
  <div id="dataManageCheckDate" style="position: relative;">
      <Card :title="$t('m.detailed_information')" style="margin-bottom: 16px">
        <div class="culture-check">
          <div class="culture-check-item" v-if="userType==1||userType==4">
            <div class="culture-check-left">{{ $t('m.gaojian_type') }}</div>
            <div class="culture-check-right">{{valData&&valData.manuscriptclassname?valData.manuscriptclassname:''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==2||userType==3">
            <div class="culture-check-left">{{ $t('m.gaojian_number') }}</div>
            <div class="culture-check-right">{{valData&&valData.number?valData.number:''}}</div>
          </div>
          <div class="culture-check-item" :style="{height:valData&&valData.titlelang&&valData.titlelang.mn? '200px':'auto'}">
            <div class="culture-check-left">{{ `${$t('m.title')}${$t('m._mn')}` }}</div>
            <div class="culture-check-right contentfont aqt_lang_mn" style="overflow-x: auto">{{valData&&valData.titlelang?(valData.titlelang.mn||''):''}}</div>
          </div>
          <div class="culture-check-item">
            <div class="culture-check-left">{{ `${$t('m.title')}${$t('m._zh')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.titlelang?(valData.titlelang.zh||''):''}}</div>
          </div>
          <div class="culture-check-item">
            <div class="culture-check-left">{{ `${$t('m.title')}${$t('m._en')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.titlelang?(valData.titlelang.en||''):''}}</div>
          </div>
          <div class="culture-check-item" :style="{height:valData&&valData.authorlang&&valData.authorlang.mn? '200px':'auto'}">
            <div class="culture-check-left">{{ `${$t('m.author')}${$t('m._mn')}` }}</div>
            <div class="culture-check-right contentfont aqt_lang_mn" style="overflow-x: auto">{{valData&&valData.authorlang?(valData.authorlang.mn||''):''}}</div>
          </div>
          <div class="culture-check-item">
            <div class="culture-check-left">{{ `${$t('m.author')}${$t('m._zh')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.authorlang?(valData.authorlang.zh||''):''}}</div>
          </div>
          <div class="culture-check-item">
            <div class="culture-check-left">{{ `${$t('m.author')}${$t('m._en')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.authorlang?(valData.authorlang.en||''):''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==2||userType==3">
            <div class="culture-check-left">{{ $t('m.gaojian_type') }}</div>
            <div class="culture-check-right">{{valData&&valData.manuscriptclassname?valData.manuscriptclassname:''}}</div>
          </div>
          <div class="culture-check-item" :style="{height:valData&&valData.keywordslang&&valData.keywordslang.mn? '200px':'auto'}">
            <div class="culture-check-left">{{ `${$t('m.keyword')}${$t('m._mn')}` }}</div>
            <div class="culture-check-right contentfont aqt_lang_mn" style="overflow-x: auto">{{valData&&valData.keywordslang?(valData.keywordslang.mn||''):''}}</div>
          </div>
          <div class="culture-check-item">
            <div class="culture-check-left">{{ `${$t('m.keyword')}${$t('m._zh')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.keywordslang?(valData.keywordslang.zh||''):''}}</div>
          </div>
          <div class="culture-check-item">
            <div class="culture-check-left">{{ `${$t('m.keyword')}${$t('m._en')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.keywordslang?(valData.keywordslang.en||''):''}}</div>
          </div>

          <div class="culture-check-item" v-if="userType==2||userType==3">
            <div class="culture-check-left">{{ `${$t('m.contributor')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.userinfo?(valData.userinfo.name?valData.userinfo.name:''):''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==2||userType==3">
            <div class="culture-check-left">{{ `${$t('m.contributor_time')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.created_at?valData.created_at:''}}</div>
          </div>

          <div class="culture-check-item" v-if="userType==1||userType==4" :style="{height:valData&&valData.zhaiyaolang&&valData.zhaiyaolang.mn? '200px':'auto'}">
            <div class="culture-check-left">{{ `${$t('m.abstract')}${$t('m._mn')}` }}</div>
            <div class="culture-check-right contentfont aqt_lang_mn" style="overflow-x: auto">{{valData&&valData.zhaiyaolang?(valData.zhaiyaolang.mn||''):''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==1||userType==4">
            <div class="culture-check-left">{{ `${$t('m.abstract')}${$t('m._zh')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.zhaiyaolang?(valData.zhaiyaolang.zh||''):''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==1||userType==4">
            <div class="culture-check-left">{{ `${$t('m.abstract')}${$t('m._en')}` }}</div>
            <div class="culture-check-right">{{valData&&valData.zhaiyaolang?(valData.zhaiyaolang.en||''):''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==1||userType==4">
            <div class="culture-check-left">{{ $t('m.references') }}</div>
            <div class="culture-check-right">{{valData&&valData.references?valData.references:''}}</div>
          </div>
          <div class="culture-check-item">
            <div class="culture-check-left">{{ userType==1||userType==4?$t('m.upload_files'):$t('m.upload_files') }}</div>
            <div class="culture-check-right" v-if="valData&&valData.files&&valData.files.length">
              <p v-for="(ite,ind) in valData.files" style="color:blue;cursor: pointer" :key="ind" @click="$download($cryptohttp.get(ite.file_url),ite.name)">{{ind+1+'、'+ite.name}}</p>
            </div>
          </div>
          <div class="culture-check-item" v-if="userType==1||userType==4">
            <div class="culture-check-left">{{ $t('m.email') }}</div>
            <div class="culture-check-right">{{valData&&valData.email?valData.email:''}}</div>
          </div>

          <div class="culture-check-item" v-if="userType==1||userType==4">
            <div class="culture-check-left">{{ $t('m.phone') }}</div>
            <div class="culture-check-right">{{valData&&valData.tel?valData.tel:''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==1||userType==4">
            <div class="culture-check-left" style="border-bottom: 0px;">{{ $t('m.copyright_statement') }}</div>
            <div class="culture-check-right" style="border-bottom: 0px">
              全体作者(著作权人)同意:论文一经《内蒙古师范大学学报(哲学社会科学版)》期刊录用，
              论文全部或部分的复制传播的权利--包括但不限于复制权、发行权、信息网络传播权、汇编权、
              广播权、表演权、翻译权、改编权等将许可给《内蒙古师范大学学报(哲学社会科学版)》编辑部使用，
              《内蒙古师范大学学报(哲学社会科学版)》编辑部除可自行使用外，
              有权许可中国知网等第三方平台使用。许可期限为著作权保护期，
              许可使用范围为全球范围内。许可使用费(含转授权费)双方另行约定
              </br>
              <Checkbox v-model="isAgree" disabled style="color: red">同意著作权授权声明</Checkbox>
            </div>
          </div>

          <div class="culture-check-item" v-if="userType==4">
            <div class="culture-check-left" style="border-top: 1px solid #dcdee2">{{ $t('m.newstage') }}</div>
            <div class="culture-check-right" style="font-weight: bold;border-top: 1px solid #dcdee2">{{valData?statusList[valData.status]:''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==4&&valData&&valData.status==2">
            <div class="culture-check-left">{{ $t('m.processing_results') }}</div>
            <div class="culture-check-right">{{valData&&valData.mark?(valData.mark.zh||valData.mark.mn):''}}</div>
          </div>
          <div class="culture-check-item" v-if="userType==4&&valData&&valData.status==2">
            <div class="culture-check-left">{{ $t('m.attachment')}}</div>
            <div class="culture-check-right" v-if="valData&&valData.markfile&&valData.markfile.length">
              <p v-for="(ite,ind) in valData.markfile" style="color:blue;cursor: pointer" :key="ind" @click="$download($cryptohttp.get(ite.file_url),ite.name)">{{ind+1+'、'+ite.name}}</p>
            </div>
          </div>

        </div>
      </Card>

      <Card v-if="userType!=4" :title="$t('m.review_record')" style="margin-bottom: 16px">
        <Table border :columns="columns" :data="data" ></Table>
      </Card>

      <Card v-if="(userType==3||userType==2)&&valData&&userData.users_id==valData.zhuanjia_id&&
valData.status!=4&&valData.status!=5" :title="$t('m.input_manuscript_comments')">
        <Form ref="form" :model="form" :rules="ruleValidate" label-position="left" :label-width="100" style="padding: 10px">
          <FormItem :label="`${$t('m.review_opinion')+$t('m._mn')}`" >
            <textarea class="textarea_mn contentfont"  v-model="form.mark.mn" :placeholder="`${$t('m.please_input')+$t('m.review_opinion')+$t('m._mn')}`"></textarea>
          </FormItem>
          <FormItem :label="`${$t('m.review_opinion')+$t('m._zh')}`">
            <Input v-model="form.mark.zh" type="textarea" :rows="5" :placeholder="`${$t('m.please_input')+$t('m.review_opinion')+$t('m._zh')}`"></Input>
          </FormItem>
          <FormItem :label="$t('m.upload_instruction_file')">
            <upload-files-oss :format="['wps','pdf','zip','rar','tiff','jpg','png']" :accept="'.wps,.pdf,.zip,.rar,.tiff,.jpg,.png'"
                              multiple :isExpert="true" @on-upload="uploadFile($event)" @on-remove="removeFiless($event)" :filedata="filedata">
            </upload-files-oss>
            <span style="color: red">*支持格式wps、pdf、zip、rar、tiff、jpg、png</span>
          </FormItem>

          <!--   status 审核中   stage  1初审 6复审 7外审 8终审-->
          <!-- 初审人-->
          <FormItem v-if="valData.stage==1" :label="$t('m.processing_results')" prop="status">
            <RadioGroup v-model="form.status" @on-change="onRadioChange">
              <Radio :label="6">复审</Radio>
              <Radio :label="7">外审</Radio>
              <Radio :label="8">终审</Radio>
              <Radio :label="4">录用稿件</Radio>
              <Radio :label="2">退修重审</Radio>
              <Radio :label="5">退稿</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="valData.stage!=1" :label="$t('m.processing_results')" prop="status">
            <RadioGroup v-model="form.status">
              <Radio :label="10">同意</Radio>
              <Radio :label="11">驳回</Radio>
            </RadioGroup>
          </FormItem>
          <!--编辑-->
          <FormItem v-if="form.status==6||form.status==8" :label="$t('m.psr')" prop="zhuanjia_id">
            <Select v-model="form.zhuanjia_id" :placeholder="`${$t('m.selectpsr')}`" filterable clearable>
              <Option v-for="(item, index) in teacherList" :value="item.users_id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <!--专家-->
          <FormItem v-if="form.status==7||(valData.status==9&&valData.stage==6)" :label="$t('m.psr')" prop="zhuanjia_id">
            <Select v-model="form.zhuanjia_id" :placeholder="`${$t('m.selectpsr')}`" filterable clearable>
              <Option v-for="(item, index) in experList" :value="item.users_id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <FormItem>
            <Button type="primary" :loading="loading" @click="handleSubmit('form')">提交</Button>
          </FormItem>
        </Form>
      </Card>

    <Spin v-if="spinLoding" fix />
  </div>
</template>

<script>
export default {
  props: {
    infoData: {
      type: [Boolean, Object,Number],
      default: false,
    },
    userType:{//4作者 3专家 2编辑 1管理员
      type: [Boolean, Number,String],
      default: false,
    }
  },

  data() {
    return {
      data: [],
      columns: [
        {
          title: this.$t('m.stage'),
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.stage?this.statusList[params.row.stage]:'')
          }
        },
        {
          title: this.$t('m.shstatus'),
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.status?this.statusList[params.row.status]:'')
          }
        },
        {
          title: this.$t('m.processing_personnel'),
          align: 'center',
          key: 'name',
        },
        {
          title: this.$t('m.time'),
          align: 'center',
          key: 'created_at',
        },
        {
          title: this.$t('m.processing_results'),
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.marklang?(params.row.marklang.zh||''):'')
          }
        },
        {
          title: this.$t('m.processing_results')+'('+this.$t('m._mn')+')',
          align: 'center',
          render: (h,params) => {
            return h('div',{
              class: {
                'contentfont': params.row.marklang&&params.row.marklang.mn?true:false,
              }
            },params.row.marklang?(params.row.marklang.mn||''):'')
          }
        },
        {
          title: this.$t('m.attachment'),
          align: 'center',
          render: (h, params) => {
            let jj = []
            if(params.row.files&&params.row.files.length){
              params.row.files.forEach((it, inde) => {
                jj[inde] = h('p',{
                  style:{
                    // float:'left',
                    color:'blue',
                    cursor:'pointer',
                    textAlign: 'left',
                  },
                  on: {
                    click: () => {
                      this.$download(this.$cryptohttp.get(it.file_url),it.name);
                    }
                  }
                },[
                  h('span',it.name?(inde+1+'、'+it.name):''),
                ])
              });
            }

            return h('div',jj)
          }
        },
      ],
      form:{
        library_id:localStorage.getItem('libId'),
        users_id:localStorage.getItem('userInfoMemberId'),
        users_type:localStorage.getItem('user_type'),
        mark:{
          mn:'',
          zh:'',
          en:''
        },//结果
        status:2,//当前稿件状态为 初审（6复审 7外审 8终审 4已录用稿件 2退修 5已退稿件）当前稿件状态为复审/外审/终审( 10同意 11驳回)
        manuscript_id:'',//材料主键id
        files:[],
        zhuanjia_id:'',//专家id
      },
      ruleValidate: {
        zhuanjia_id:[
          { required: true,type:'number',message: '请选择评审人员', trigger: 'change' }
        ],
        status:[
          { required: true,type:'number',message: '请选择评审状态', trigger: 'change' }
        ]
      },
      filedata:{
        library_id:localStorage.getItem('libId'),
        model:'Contribute',//模块 book_afterRead读后感  book书籍图片
        filetype:'file',//images（图片）、video（视频）、audio（音频）、file（文件）
      },
      loading:false,
      isAgree:true,
      spinLoding:false,


      valData:'',
      statusList:['未审核','初审','作者修改中','作者修回稿件','已录用稿件','已退稿件','复审','外审','终审','审核中','审核通过','驳回'],
      userData:'',

      experList:[],
      teacherList:[],
    }
  },

  methods: {
    onRadioChange(){
      if(this.form.status!=6 &&this.form.status!=7&&this.form.status!=8){
        this.form.zhuanjia_id = ''
      }
    },
    /*****************************************************************
     * 多文件上传
     *****************************************************************/
    uploadFile(data) {
      let that = this
      that.form.files = data.map((item) => {
        if (item.response) {
          if (item.response.code == 200) {
            return item.response.data.id
          }
        } else {
          return item.id
        }
      })
    },
    /*****************************************************************
     * 多图删除
     *****************************************************************/
    removeFiless(data) {
      let that = this
      that.form.files = data.map((item) => {
        if (item.response) {
          if (item.response.code == 200) {
            return item.response.data.id
          }
        } else {
          return item.id
        }
      })
    },
    /*****************************************************************
     * 表单验证
     * @param   {name}             要验证的表单名称
     *****************************************************************/
    handleSubmit(name) {
      let that = this
      if(that.valData.stage==1&&that.form.status!=6
          &&that.form.status!=7&&that.form.status!=8){
        that.form.zhuanjia_id = ''
      }
      that.$refs[name].validate((valid) => {
        if (valid) {
          that.loading = true
          that.form.manuscript_id = that.infoData
          let ss = JSON.parse(JSON.stringify(that.form))
          ss.mark = JSON.stringify(ss.mark)
          that.$httpsencrypt.post('api/contributeweb/v3/auditdata/add', ss).then(val => {
            that.$emit('operationState', true,'isindex')
            that.loading = false
            that.$Message.success('提交成功!');
          }).catch(err => {
            that.loading = false
          })
        }
      })
    },

    selData() {
      this.spinLoding = true
      let cond = {
        id:this.infoData,
      }
      this.$httpsencrypt.post('api/contributeweb/v3/manuscript/info',cond).then(val => {
        this.valData = val.data
        if(this.valData.status==9&&this.valData.stage==1){
          //初审
          this.form.status = 6
        }else {
          //复审、外审、终审
          this.form.status = 10
        }

        this.spinLoding = false
      }).catch(err => {
        this.spinLoding = false
      })
    },
    getpsjlList(){
      const _this = this
      let cond = {
        library_id:localStorage.getItem('libId'),
        manuscript_id:this.infoData
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/auditdata/index`,cond)
          .then(val =>{
            if(val.code==200&&val.data.length){
              _this.data = val.data
            }else {
              _this.data = []
            }
          }).catch(err =>{
        _this.data = []
      })
    },

    getExperList(){
      const _this = this
      let cond = {
        library_id:localStorage.getItem('libId'),
        user_type:3
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/users/index`,cond)
          .then(val =>{
            if(val.code==200&&val.data.length){
              _this.experList = val.data
            }else {
              _this.experList = []
            }
          }).catch(err =>{
        _this.experList = []
      })

      let cond1 = {
        library_id:localStorage.getItem('libId'),
        user_type:2
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/users/index`,cond1)
          .then(val =>{
            if(val.code==200&&val.data.length){
              _this.teacherList = val.data
            }else {
              _this.teacherList = []
            }
          }).catch(err =>{
        _this.teacherList = []
      })
    },
  },

  mounted() {
    this.userData = JSON.parse(this.userInfo)
    this.selData()
    if(this.userType!=4){
      this.getpsjlList()
      this.getExperList()
    }

  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  watch: {
    userInfo: {
      handler(val, oldValue) {
        this.userData = val?JSON.parse(val):''
      },
      deep: true
    }
  },
}
</script>

<style lang="less" scoped>
.culture-check {
  // width: 100%;
  // background-color: aqua;
  //border: 1px solid #dcdee2;
  position: relative;

  &-item {
    display: flex;
  }

  &-item:first-child {
    border: none;
  }

  &-left {
    flex: 1;
    font-weight: bold;
    padding: 10px;
    //max-height: 150px;
    min-height: 42px;
    display: flex;
    align-items: center;
    border-right: 1px solid #dcdee2;
    border-bottom: 1px solid #dcdee2;
  }

  &-right {
    flex: 6;
    padding: 10px;
    border-bottom: 1px solid #dcdee2;
  }

  &-title {
    height: 100px;
    overflow-x: auto;
  }
}
</style>

<style lang="less">
#dataManageCheckDate{
  .ivu-card-body{
    padding: 0!important;
  }
}
</style>
